import Task from "../../../../model2/task/task";

// const debug = "taskMore_getMoveOptions"
const debug = false

export default function taskMore_getMoveOptions(task: Task, hidePopover: func, onMove?: func) {

    const taskSystemType = _.get(task, 'systemType', gd.const.task.systemType.TASK)

    const onClickMoveToFolder = () => {
        hidePopover()
        task.moveToFolder(onMove)
    }

    const onClickMoveToTask = () => {
        hidePopover()
        task.moveToTask(onMove)
    }

    const onConvertToTask = () => {
        hidePopover()
        task.convertToTask(onMove)
    }

    const options = []

    options.push({
        icon        : "i5-project",
        label       : "Move to project",
        onClick     : onClickMoveToFolder,
    })

    switch (taskSystemType) {
        case gd.const.task.systemType.SUBTASK:
            options.push({
                icon:        'i5-subtask-convert',
                label       : "Move to task",
                onClick     : onClickMoveToTask,
            })
            options.push({
                icon        : 'i5-task-convert',
                label       : "Convert to task",
                onClick     : onConvertToTask,
            })
            break

        case gd.const.task.systemType.TASK:
            options.push({
                icon        : 'i5-subtask-convert',
                label       : "Convert to subtask",
                onClick     : onClickMoveToTask,
            })
            break
    }

    return options
}